import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { PhonePipe } from '../../../shared/pipe/phone.pipe';
import {CustomerService} from '../../../shared/service/customer.service';
import {Customer} from '../../../shared/model/customer';
import { ActivatedRoute, Router } from '@angular/router';
import { SaveHttpError } from '../../../shared/error/save-http-error';
import { UpdateHttpError } from '../../../shared/error/update-http-error';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-customer-create-update',
  templateUrl: './customer-create-update.component.html',
  styleUrls: ['./customer-create-update.component.css']
})
export class CustomerCreateUpdateComponent implements OnInit, AfterViewChecked {
  newCustomer: Customer;
  partialTitle: string;
  private customerId: number;
  private phonePipe: PhonePipe;
  private editMode = false;

  constructor(private _customerService: CustomerService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _toastService: ToastService) {
    this.setUpObjects();
    this.editModeVerify();
    this.setPipes();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  save() {
    this.handleBooleanFields();
    if (this.editMode) {
      this._customerService.update(this.newCustomer);
    } else {
      this._customerService.save(this.newCustomer);
    }
  }

  editModeVerify() {
    this.partialTitle = 'Cadastrar ';
    this._route.params.subscribe(params => {
      if (params['id']) {
        this.editMode = true;
        this.customerId = +params['id'];
        this._customerService.findById(this.customerId);
        this.partialTitle = 'Editar ';
      }
    });
  }

  checkBagStayAtCustomer() {
    this.newCustomer.equipmentBagStayInCustomer = !this.newCustomer.equipmentBagStayInCustomer;
  }

  checkAwaitingReturn() {
    this.newCustomer.equipmentAwaitingReturnOnCustomer = !this.newCustomer.equipmentAwaitingReturnOnCustomer;
  }

  private handleBooleanFields() {
    this.newCustomer.equipmentBagStayInCustomer = !!this.newCustomer.equipmentBagStayInCustomer;
    this.newCustomer.equipmentAwaitingReturnOnCustomer = !!this.newCustomer.equipmentAwaitingReturnOnCustomer;
  }

  private setUpObjects() {
    this.newCustomer = new Customer();
  }

  private setUpObservers() {
    if (this.editMode) {
      this.setUpSaveUpdateAction(this._customerService.update$);
    } else {
      this.setUpSaveUpdateAction(this._customerService.save$);
    }
    this.setUpFindAction(this._customerService.find$);
    this.setUpErrorAction(this._customerService.error$);
  }

  private setUpSaveUpdateAction(observable) {
    observable
      .subscribe(() => {
        this.goBack();
      });
  }

  private setUpFindAction(observable) {
    observable
      .filter(customer => customer instanceof Customer)
      .subscribe(customer => {
        this.newCustomer = customer;
      });
  }

  private setUpErrorAction(observable) {
    observable
      .filter(error => error instanceof SaveHttpError || error instanceof UpdateHttpError)
      .subscribe(error => this._toastService.showMessage(error.text, 4000));
  }

  setPipes() {
    this.phonePipe = new PhonePipe();
  }

  applyPhoneMask(event) {
    return this.phonePipe.transform(event.target.value, event.key);
  }

  goBack() {
    this._router.navigate(['customers/list']);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/customer/component/customer-create-update/customer-create-update.component.ts